var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "popupContainer",
      attrs: {
        visible: true,
        fullscreen: true,
        "modal-append-to-body": true,
        "append-to-body": true,
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
        title: _vm.showTypesModal
          ? "选择需求类型"
          : "请预留您的联系方式及需求信息",
        center: true,
      },
    },
    [
      !_vm.showTypesModal
        ? _c(
            "div",
            {
              staticClass:
                "introductionBox f-3 as-flex flex-vertical main-start cross-center",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "indicator-sub-title as-flex main-center cross-center f-2 fc-gray-2",
                },
                [_vm._v("众观智影为您提供精准的定制数据服务")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "indicator-content as-flex flex-vertical main-center cross-center",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mobile-row as-flex main-start cross-center",
                    },
                    [
                      _c("div", { staticClass: "mobile-title" }, [
                        _vm._v("联系方式"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mobile-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mobile,
                              expression: "mobile",
                            },
                          ],
                          attrs: { type: "text", placeholder: "请填写" },
                          domProps: { value: _vm.mobile },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.mobile = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mobile-row as-flex main-start cross-center",
                    },
                    [
                      _c("div", { staticClass: "mobile-title" }, [
                        _vm._v("公司名称"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mobile-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.company,
                              expression: "company",
                            },
                          ],
                          attrs: { type: "text", placeholder: "请填写" },
                          domProps: { value: _vm.company },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.company = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mobile-row as-flex main-start cross-center",
                    },
                    [
                      _c("div", { staticClass: "mobile-title" }, [
                        _vm._v("影片名"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mobile-input" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.movie,
                              expression: "movie",
                            },
                          ],
                          attrs: { type: "text", placeholder: "请填写" },
                          domProps: { value: _vm.movie },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.movie = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "mobile-row as-flex main-start cross-center",
                    },
                    [
                      _c("div", { staticClass: "mobile-title" }, [
                        _vm._v("需求类型"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "types-input as-flex main-start cross-center",
                          on: { click: _vm.showTypes },
                        },
                        [
                          _vm.chosenTypes.length === 0
                            ? _c("div", { staticClass: "fc-gray-4 type-btn" }, [
                                _vm._v("请选择"),
                              ])
                            : _c("div", { staticClass: "types-container" }, [
                                _vm._v(_vm._s(_vm.chosenTypesText)),
                              ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "requirementDetail-row as-flex main-center cross-center",
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionDetail,
                            expression: "questionDetail",
                          },
                        ],
                        staticClass: "requirementDetail",
                        attrs: { placeholder: "您要解决的问题是?" },
                        domProps: { value: _vm.questionDetail },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.questionDetail = $event.target.value
                          },
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "error as-flex main-start cross-center f-1",
                    },
                    [_vm._v(_vm._s(_vm.error.msg))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "confirm-btn as-flex main-center cross-center f-3",
                  on: { click: _vm.confirm },
                },
                [_vm._v("提交")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTypesModal
        ? _c("div", { staticClass: "types-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "indicator-content type-container as-flex flex-vertical main-start cross-start",
              },
              [
                _vm._l(
                  Object.assign(_vm.typesMapping || {}),
                  function (title, index) {
                    return [
                      _c(
                        "div",
                        { key: "title_" + index, staticClass: "as-full-width" },
                        [
                          _c("div", { staticClass: "typeTitle f-4" }, [
                            _vm._v(_vm._s(title ? title.name : "--")),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "typeDetailContainer as-flex flex-vertical main-start cross-center",
                            },
                            [
                              _vm._l(title ? title.data : [], function (item) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      key: item.id,
                                      class: [
                                        "type-box ",
                                        "as-flex",
                                        "flex-vertical",
                                        "main-center",
                                        "cross-center",
                                        _vm.chosenTypes.find(function (ele) {
                                          return ele.id === item.id
                                        })
                                          ? "is-selected"
                                          : "",
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.chooseType(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [_vm._v(_vm._s(item.title))]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "f-1 fc-gray-2" },
                                        [_vm._v(_vm._s(item.desc))]
                                      ),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  }
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "confirm-container as-flex main-center cross-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "confirm-btn as-flex main-center cross-center f-5",
                    on: { click: _vm.confirmTypes },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }